function seekToAction(playerRef: HTMLElement, videoDuration: number) {
    const queryParams = new URLSearchParams(window.location.search);
    const timestamp = Number.parseInt(queryParams.get("t") ?? "");
    const videoPlayerElement = playerRef?.getElementsByTagName("video")[0];
    if (
        videoPlayerElement &&
        timestamp &&
        timestamp > 0 &&
        timestamp < videoDuration
    ) {
        videoPlayerElement.addEventListener("loadedmetadata", () => {
            videoPlayerElement.currentTime = timestamp;
        });
    }
}
export default seekToAction;
